import { Product, VulnerabilityType } from './product';

export enum LeadSource {
  drops = 'Web Onboarding Drops',
  complete = 'Web Onboarding',
  prospect = 'Web Onboarding Prospects',
}

export enum Status {
  init = 'init',
  step1 = 'step1',
  step2 = 'step2',
  step3 = 'step3',
  step4 = 'step4',
  complete = 'complete',
  sent = 'sent',
  callme = 'callme',
}

export const statusOrder = {
  init: 0,
  step1: 0,
  step2: 1,
  step3: 2,
  step4: 3,
  complete: 4,
  sent: 5,
};

export const getStepNumber = (status: Status | string): number =>
  statusOrder[status];

export const getStepByNumber = (num: number): Status => {
  return Object.keys(statusOrder).find(
    (step) => statusOrder[step] === num
  ) as Status;
};

export const attivazioneEndpoint = 'activation';

export enum AttivazioneType {
  onboarding = 'Onboarding',
  callme = 'Callme',
}

export enum NotorietaRadio {
  modificato = 'modificato',
  non_modificato = 'non modificato',
  tecnologico = 'tecnologico',
  nulla = '',
}

export interface Attivazione {
  firstname: string;
  lastname: string;
  fullName: string;
  email: string;
  phone: number;
  webStatus: Status;
  sendEmail: boolean;
  typeId: AttivazioneType;
  leadSource: LeadSource;
  province: string;
  fornitureType: string;

  istanzaFilled1: any;
  istanzaFilled2: any;
  istanzaFilled3: any;
  istanzaFilled4: any;
  idCard1: any;
  idCard2: any;

  _id?: string;
  id?: string;
  opportunityStatus: string;
  lightGreen: boolean;
  contractSent: string;
  opportunityId: string;
  opportunityRecallId: string;
  promoCode: string;
  cteCondition: boolean;
  cfgCondition: boolean;
  cadastralCondition: boolean;
  clauseCondition: boolean;
  consentsCondition: boolean;
  privacyComCom: boolean;
  privacyProf: boolean;
  privacyQualServ: boolean;
  privacyComTer: boolean;
  privacyProfTer: boolean;
  categoryNumber: number;
  function: string;
  product: any;
  completed: boolean;
  operatorRatingCode: AttivazioneFeedback;
  operatorRating: string;
  ctePolicyUrl: string;
  cfgPolicyUrl: string;
  generalPolicyUrl: string;

  birthPlace: string;
  birthDate: string;
  cf: string;
  cadCity: string;
  cadAddress: string;
  cadNumber: string;
  cadStaircase: string;
  cadFloor: string;
  cadInternal: string;
  cadSection: string;
  cadSheet: string;
  cadMap: string;
  cadSubaltern: string;
  cadRadio1: boolean;
  cadRadio2: boolean;
  cadRadio3: boolean;
  cadRadio4: boolean;
  cadRadio5: boolean;
  cadRadio6: boolean;
  cadBuildingPermit: string;
  cadBuildingPermitDate: string;
  cadBuildingPermitCity: string;
  cadAmnesty: string;
  cadAmnestyDate: string;
  cadAmnestyCity: string;
  //punto 3
  cadDIADate: string;
  cadDIACity: string;
  //punto 4
  cadPermit: string;
  cadPermitDate: string;
  cadPermitCity: string;
  //punto 6
  cadLicenceDate: string;
  cadLicenceCity: string;
  //titolo di possesso immobile
  titleRadio1: boolean;
  titleRadio2: boolean;
  titleRadio3: boolean;
  titleRadio4: boolean;
  //Locazione
  leaseCity: string;
  leaseDate: string;
  leaseNumber: string;
  //usufrutto
  usufruct: string;
  //altro da specificare
  other: string;
  // veneto
  venetoDate: string;
  venetoCity: string;
  venetoStart: string;
  venetoRadio: string;
  // notorieta
  notorietaRadio: NotorietaRadio;
  //signature
  signatureLocation: string;
  signatureDate: string;
  //otp
  otpValidateRequest: boolean;
  Alg_OTPCheck__c: boolean;
  Alg_OTPCheckDate__c: string;
  //linear
  linearGas: boolean,
  linearLuce: boolean,

  //vulnerable product
  NewProductName?: string
  vulnerabilityType?: VulnerabilityType | null;
  vulnerabilityTypeUserSelected?: VulnerabilityType | null;
}

export type AttivazioneFeedback = 100 | 200 | 300 | 400;

export interface AttivazioneResponse {
  status: number;
  attivazione: Attivazione;
}

export interface AttivazionePrivacyConsents {
  generalPrivacy: boolean;
  privacyComCom: boolean;
  privacyProf: boolean;
  privacyQualServ: boolean;
  privacyComTer: boolean;
  privacyProfTer: boolean;
}

export interface AttivazioneGenericConsents {
  cteCondition: boolean;
  cfgCondition: boolean;
  cadastralCondition: boolean;
  clauseCondition: boolean;
  consentsCondition: boolean;
}

export interface ApprovalPromoNameAndDiscount {
  isDiscount: boolean;
  promoName: string;
}

export interface AttivazioneLastToSf {
  notorietaRadio: NotorietaRadio;
}

export interface AttivazioneConsents
  extends AttivazionePrivacyConsents,
    AttivazioneGenericConsents,
    AttivazioneLastToSf {}



// WEBPACK FOOTER //
// ./src/app/models/attivazione.ts